import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Badge from '../badge/badge';
import defaultStyles from './staff-pick-badge.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class StaffPickBadge extends React.PureComponent<Props> {
    render() {
        const { styles } = this.props;
        return (
            <Link className={styles.link} to='/blogs/staff-picks/'>
                <Badge style={{ badge: styles.badge }} uppercase={true}>
                    <FormattedMessage id='STAFFPICKS_BADGE'>
                        {msg => <span>{(msg as string).toUpperCase()}</span>}
                    </FormattedMessage>
                </Badge>
            </Link>
        );
    }
}

export default Styled(defaultStyles)(StaffPickBadge);
